import styled from "styled-components";
import Button from "../../Button";
import {Repo, RepoInfo} from "../../../api/types";
import {useState} from "react";
import BranchModel from "./BranchModel";
import {useNavigate} from "react-router-dom";
import JobSettings from "../JobSettings";
import {agent} from "../../../api/agent";

interface Props {
    repo: RepoInfo;
    updateRepo: () => void;
}

const Center = styled.div`
    display: flex;
    justify-content: center;

    .right {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        font-size: 1.2rem;
    }

`;

const Container = styled.div`
    width: 80%;
`;

export default function ActionBar({repo, updateRepo}: Props) {

    const [settingsOpen, setSettingsOpen] = useState(false);
    const [branchOpen, setBranchOpen] = useState(false);
    const navigate = useNavigate();

    return <>
        <BranchModel open={branchOpen} repo={repo.repo} onClose={() => setBranchOpen(false)}></BranchModel>
        <JobSettings repo={repo} open={settingsOpen} close={() => setSettingsOpen(false)} updateRepo={updateRepo}></JobSettings>
        <Center>
            <Container>
                <div className={'right'}>
                    <Button className={'primary'} onClick={() => setSettingsOpen(true)}><i
                        className="fa-solid fa-gear"></i></Button>
                    <Button className={'primary'} onClick={() => setBranchOpen(true)}><i
                        className="fa-solid fa-code-branch"></i></Button>
                    <Button className={'primary'} onClick={() => navigate('pipeline-builder?skeleton=' + repo.lastSkeleton?.id)}><i
                        className="fa-solid fa-pen"></i></Button>
                    <Button className={'red'} onClick={() => agent.deleteRepo(repo.repo.repo).then(() => navigate('/'))}><i
                        className="fa-solid fa-trash"></i></Button>
                </div>
            </Container>
        </Center>
    </>;
}

